import React, {useEffect, useState} from 'react'
import * as api from '@api'
import {useQuery} from '@/hooks/useApi'
import useToast from '@/hooks/useToast'
import {useAuth} from '@state/auth'
import ErrorToast from '@components/ErrorToast'

export default function useImpactAreasList() {
  const {toast} = useToast()
  const [data, setData] = useState([])
  const isAdmin = useAuth(state => state.isAdmin)
  const queryParams = {isDropDown: true}

  const result = useQuery(
    'getImpactAreasDropdown',
    () => (isAdmin() ? api.adminGetCategories(queryParams) : api.getCategories(queryParams)),
    {
      gcTime: 24 * 3600 * 1000,
    }
  )

  useEffect(() => {
    if (result.isSuccess && result.data) {
      const {status, error, data: responseData} = result.data
      if (status >= 400) {
        toast.custom(t => <ErrorToast t={t} error={error} />)
      } else {
        setData(responseData?.data)
      }
    }
  }, [result.isSuccess, result.data])

  return data
}
